import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from "../../../auth/auth.service";
import {UserNotificationService} from "../../../auth/notification/user-notification.service";
import {PageResult} from "../../../shared/page-result";
import {UserNotification} from "../../../auth/notification/user-notification";
import {Router} from "@angular/router";

@Component({
  selector: 'app-nav-notifications-list',
  templateUrl: './nav-notifications-list.component.html',
  styleUrls: ['./nav-notifications-list.component.scss']
})
export class NavNotificationsListComponent implements OnInit {

  @Output() decrement : EventEmitter<boolean> = new EventEmitter();

  isLogged = false;

  authUnavailable = false;

  private readonly page: number = 0;

  private readonly pageSize: number = 100;

  private notificationPage: PageResult<UserNotification>;

  userNotifications: UserNotification [] = [];

  constructor(private notificationService: UserNotificationService,
              private authService: AuthService,
              private route: Router) {
  }

  ngOnInit() {
    this.authService.isLogged.subscribe(value => {
      this.isLogged = value;
    });
    this.authService.authUnavailable.subscribe(value => {
      this.authUnavailable = value;
    });
    this.authService.getToken().then(token => {
      this.notificationService.getUserNotifications(this.page, this.pageSize, token).subscribe(notifications => {
        this.notificationPage = notifications;
        this.userNotifications = notifications.content;
      });
    }, error => {
      console.error(error);
    });
  }

  goToTarget(notification: UserNotification , index: number) {
    if (notification.type === 'QUERY') {
      this.route.navigateByUrl(`/search/b?filters=${notification.filter}&pageSize=${notification.pageSize}&sort=modificationTime:desc`);
    }
    this.markAsReadAction(notification, index);
  }

  markAsReadAction(notification: UserNotification , notificationIndex: number) {
      this.authService.getToken().then(token => {
        this.notificationService.markAsRead(notification.queryId, token).subscribe(value => {
          this.userNotifications.splice(notificationIndex,1);
        });
      });
      this.decrement.emit(true);
  }

}
